import { render, staticRenderFns } from "./CancelBrandSubscription.vue?vue&type=template&id=10fd0de2&scoped=true&"
import script from "./CancelBrandSubscription.vue?vue&type=script&lang=ts&"
export * from "./CancelBrandSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./CancelBrandSubscription.vue?vue&type=style&index=0&id=10fd0de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd0de2",
  null
  
)

export default component.exports